import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  return (
    <div className="brand-gradient-bg flex min-h-[100dvh] items-center justify-center px-4">
      <div className="max-w-md text-center">
        <p className="brand-pill-recommended mb-4 inline-flex">404</p>
        <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
          Page not found
        </h1>
        <p className="mt-3 text-muted-foreground">
          The URL you opened doesn't match any HosterDash route.
        </p>
        <Button asChild className="mt-6">
          <Link to="/dashboard">Back to dashboard</Link>
        </Button>
      </div>
    </div>
  );
}
